export default {
  methods: {
    utag (category, action, label) {
      window.utag_data.event_category = `BusinessTelcoComparison_${category}`
      window.utag_data.event_action = `send${action}Event`
      window.utag_data.event_label = `BusinessTelcoComparison_${label}`
      window.utag_data.event_value = ''
      window.utag_data.event_details = ''

      if (typeof window.utag !== 'undefined') {
        window.utag.link(window.utag_data)
      }
    },
    gtmTagging (name, success) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'formSubmission',
        'form': {
          'category': 'telco',
          'id': 'voip-journey',
          'name': name,
          'product': 'voip',
          'productCategory': 'telco',
          'status': 'submit',
          'success': success,
          'type': 'journey'
        }
      })
    },
    voipUser (vuClass, id, name, text) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'button',
        'button': {
          'class': vuClass,
          'id': id,
          'name': name,
          'text': text,
          'type': 'submit'
        }
      })
    },
    generalTracking (buttonData) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        'event': 'button',
        'button': { ...buttonData }
      })
    }
  }
}
